<!--
 * @Author: wsx
 * @Date: 2022-03-05 14:25:16
 * @LastEditTime: 2022-03-05 16:49:38
 * @Description:力量装备
 * @FilePath: \smart-community\src\views\smartApplication\threeSolidQuery\components\power.vue
-->
<template>
  <div class="power">
    <div class="tab-box">
      <el-radio-group v-model="tab" size="large">
        <el-radio-button label="1">力量</el-radio-button>
        <el-radio-button label="2">装备</el-radio-button>
      </el-radio-group>
    </div>
    <ul class="search-results" v-show="tab === '1'">
      <template v-for="(item, index) in populationlist" :key="index">
        <li class="results-item">
          <div class="item-img">
            <img
              v-if="item.prisonInfo.imageUrl"
              :src="url + item.prisonInfo.imageUrl"
              alt=""
            />
            <img v-else src="~@/assets/images/moren.png" alt="" />
          </div>
          <div class="item-details">
            <div class="details-info">
              <span class="label">
                <el-link type="success" @click="clickPersonFn(item)">{{
                  item.prisonInfo.name
                }}</el-link>
              </span>
              <span class="value">{{ item.prisonInfo.sexDict }}</span>
            </div>
            <div class="details-info">
              <span class="label">证件号码：</span>
              <span class="value">{{ item.prisonInfo.cardNumber }}</span>
            </div>
            <div class="details-info">
              <span class="label">手机号码：</span>
              <span class="value">{{ item.prisonInfo.telphone }}</span>
            </div>
            <div class="details-info">
              <span class="label">户籍地：</span>
              <span class="value">{{ item.prisonInfo.registerDetail }}</span>
            </div>
          </div>
        </li>
      </template>
    </ul>
    <ul class="search-results" v-show="tab === '2'">
      <template v-for="(item, index) in equipmentlist" :key="index">
        <li class="results-item">
          <div class="item-img">
            <img v-if="item.imageUrl" :src="url + item.imageUrl" alt="" />
            <img v-else src="~@/assets/images/moren.png" alt="" />
          </div>
          <div class="item-details">
            <div class="details-info">
              <span>{{ item.equipmentName }}</span>
            </div>
            <div class="details-info">
              <span class="label">负责人</span>
              <span class="value">
                <el-link type="success" @click="clickPersonFn(item)">{{
                  item.prisonInfo.name
                }}</el-link>
              </span>
            </div>
            <div class="details-info">
              <span class="label">手机号码</span>
              <span class="value">{{ item.telphone }}</span>
            </div>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import { queryUserList } from "@/api/realPopulation/realPopulation.js";
import { equipmentlist, strengthlist } from "@/api/threeSolid/threeSolid.js";
export default defineComponent({
  name: "power",
  components: {},
  setup(props, context) {
    const data = reactive({
      tab: "1",
      populationlist: [],
      equipmentlist: [],
      url: window.imgURL,
    });
    const refData = toRefs(data);
    const clickPersonFn = (item) => {
      context.emit("clickPerson", item);
    };
    // 请求数据
    const queryData = (params) => {
      console.log("power-请求数据-参数", params);
      if (data.tab === "1") {
        return getpopulation(params);
      } else {
        return getequipmentlist(params);
      }
    };
    // 获取人口
    const getpopulation = async (search) => {
      const params = {
        page: 1,
        limit: 10000,
      };
      if (search) {
        params.search = search;
      }
      const res = await strengthlist(params);
      data.populationlist = res.page.list;
      return res.page.totalCount;
    };
    // 获取装备
    const getequipmentlist = async (search) => {
      const params = {
        page: 1,
        limit: 10000,
      };
      if (search) {
        params.search = search;
      }
      const res = await equipmentlist(params);
      data.equipmentlist = res.page.list;
      return res.page.totalCount;
    };

    getpopulation();
    getequipmentlist();
    return {
      ...refData,
      clickPersonFn,
      queryData,
      getpopulation,
      getequipmentlist,
    };
  },
});
</script>
<style lang="scss" scoped>
.power {
  @include flex-col-s-c;
  .tab-box {
    @include flex-row-c-c;
  }
  .search-results {
    width: 100%;
    flex: 1;
    overflow: auto;
    margin-top: 5px;
    .results-item {
      padding: 10px 0;
      width: 100%;
      height: 24%;
      border-bottom: 1px solid #aab2c5;
      @include flex-row-s-c;
      .item-img {
        width: 35%;
        height: 80%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item-details {
        flex: 1;
        margin-left: 10px;
        line-height: 28px;
        width: 65%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: flex-start;
        .details-info {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          & > span {
            // display: inline-block;
          }
          .label {
            display: inline-block;
            width: 65px;
          }
          .value {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
